export default {
	"time": {
		"formats": {
			"default": "DD/MM/YYYY H:mm",
			"yesterdayAt": "[Gisteren om] H:mm",
			"hoursAgo": "H [uur geleden]",
			"minutesAgo": "m [minuten geleden]",
			"aMinuteAgo": "m [minuut geleden]",
			"justNow": "[Enkele seconden geleden]"
		}
	},
	"channel_list": {
		"show_full_list": "Alle zenders"
	}
}
